export interface IImageBlockImage {
    content: string;
    externalAuthorName?: string;
    externalAuthorUrl?: string;
    externalPhotoUrl?: string;
    externalMediaflowId?: number;
}

const toImageBlockImage = (source: any): IImageBlockImage => {
    const image: IImageBlockImage = {
        content: source.content,
    };

    if (source.externalAuthorName) {
        image.externalAuthorName = source.externalAuthorName;
        image.externalAuthorUrl = source.externalAuthorUrl;
        image.externalPhotoUrl = source.externalPhotoUrl;
    }

    if (source.externalMediaflowId) {
        image.externalMediaflowId = source.externalMediaflowId;
    }

    return image;
};

export const parseImageBlockContent = (content: string): IImageBlockImage[] => {
    if (!content) {
        return [];
    }

    if (content[0] !== "{") {
        return [{ content }];
    }

    try {
        const parsed = JSON.parse(content);

        if (Array.isArray(parsed.images)) {
            return parsed.images
                .filter((image) => !!image?.content)
                .map(toImageBlockImage);
        }

        return parsed.content ? [toImageBlockImage(parsed)] : [];
    } catch {
        return [];
    }
};

export const serializeImageBlockContent = (images: IImageBlockImage[]): string => {
    if (images.length === 0) {
        return "";
    }

    return JSON.stringify({
        ...images[0],
        images,
    });
};

export const toImageBlockImageFromSelection = (selected: any): IImageBlockImage => {
    return toImageBlockImage({
        ...selected,
        content: String(selected.thumbnailUrl || selected.url || selected.imageUrl || selected.content || ""),
    });
};
